export const LOAD_CUSTOMER_TASKS = 'LOAD_CUSTOMER_TASKS';

export function loadCustomerTasks(data) {
    return {
      type: LOAD_CUSTOMER_TASKS,
      payload: data,
    }
  }
  


// WEBPACK FOOTER //
// ./src/actions/customer/index.js